import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import Checkout from "./CheckOut";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductById } from "../features/product/productSlice";
import { addToCart } from "../features/userfeatures/cart/cartUserSilce";
// import {
//   faFacebookF,
//   faLinkedinIn,
//   faTwitter,
//   faInstagram,
//   faWhatsapp,
// } from "@fortawesome/free-brands-svg-icons";
import "./LandingPage.css";
import {
  addToWishlistAsync,
  removeFromWishlistAsync,
} from "../features/wishlist/wishlistSlice";
import Navbar from "./Navbar";
import Footer from "./layouts/Footer";

const ProductPage = () => {
  const [quantity, setQuantity] = useState(1);
  const { id } = useParams();
  console.log("Product ID:", id);
  const dispatch = useDispatch();
  const { product, loading, error } = useSelector((state) => state.product);
  console.log("product:", product);
  const {
    wishlist,
    loading: wishlistLoading,
    error: wishlistError,
  } = useSelector((state) => state.wishlist);
  console.log("items", wishlist);

  const { loading: cartLoading, error: cartError } = useSelector(
    (state) => state.cartUser
  ); // To check cart status
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    dispatch(getProductById(id));
    if (product?.title) {
      console.log(
        "imageMapping for product title:",
        imageMapping[product.title]
      );
    }
  }, [dispatch, product, id]);

  // Functions to handle modal visibility
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const isInWishlist = wishlist.some((item) => item.product_id === id) || false;
  // const fallbackImages = [
  //   {
  //     id: 1,
  //     src: "/assets/images/items/16.jpg",
  //     alt: "Spiral binding notebook ",
  //   },
  //   {
  //     id: 2,
  //     src: "/assets/images/items/20.jpg",
  //     alt: "Spiral binding notebook",
  //   },
  //   {
  //     id: 3,
  //     src: "/assets/images/items/25.jpg",
  //     alt: "Spiral binding notebook",
  //   },
  // ];

  const imageMapping = {
    "Shorthand copy": [
      { id: 1, src: "/assets/images/items/1.jpg", alt: "Shorthand copy" },
      { id: 13, src: "/assets/images/items/13.jpg", alt: "Shorthand copy" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Duplicate book 1/12": [
      { id: 2, src: "/assets/images/items/2.jpg", alt: "Duplicate book 1/12" },
      { id: 4, src: "/assets/images/items/4.jpg", alt: "Duplicate book 1/12" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    Daybook: [
      { id: 3, src: "/assets/images/items/3.jpg", alt: "Daybook" },
      { id: 6, src: "/assets/images/items/6.jpg", alt: "Daybook" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Duplicate book 1/8": [
      { id: 5, src: "/assets/images/items/5.jpg", alt: "Duplicate book 1/8" },
      { id: 7, src: "/assets/images/items/7.jpg", alt: "Duplicate book 1/8" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Duplicate book 1/16": [
      { id: 8, src: "/assets/images/items/8.jpg", alt: "Duplicate book 1/16" },
      { id: 9, src: "/assets/images/items/9.jpg", alt: "Duplicate book 1/16" },
      {
        id: 17,
        src: "/assets/images/items/17.jpg",
        alt: "Duplicate book 1/16",
      },
      {
        id: 18,
        src: "/assets/images/items/18.jpg",
        alt: "Duplicate book 1/16",
      },
    ],
    "Red cloth corner Register": [
      {
        id: 10,
        src: "/assets/images/items/10.jpg",
        alt: "Red cloth corner Register",
      },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Duplicate Book 1/6": [
      { id: 11, src: "/assets/images/items/11.jpg", alt: "Duplicate Book 1/6" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Red cloth copy": [
      { id: 12, src: "/assets/images/items/12.jpg", alt: "Red cloth copy" },
      { id: 19, src: "/assets/images/items/19.jpg", alt: "Red cloth copy" },
      { id: 23, src: "/assets/images/items/23.jpg", alt: "Red cloth copy" },
    ],
    "Red daybook": [
      { id: 14, src: "/assets/images/items/14.jpg", alt: "Red daybook" },
      { id: 15, src: "/assets/images/items/15.jpg", alt: "Red daybook" },
      { id: 24, src: "/assets/images/items/24.jpg", alt: "Red daybook" },
    ],
    "Spiral binding notebook": [
      {
        id: 16,
        src: "/assets/images/items/16.jpg",
        alt: "Spiral binding notebook",
      },
      {
        id: 25,
        src: "/assets/images/items/25.jpg",
        alt: "Spiral binding notebook",
      },
      {
        id: 20,
        src: "/assets/images/items/20.jpg",
        alt: "Spiral binding notebook",
      },
    ],
    "Office Registers": [
      { id: 21, src: "/assets/images/items/21.jpg", alt: "Office Registers" },
      { id: 22, src: "/assets/images/items/22.jpg", alt: "Office Registers" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Red cloth Bounded Register": [
      {
        id: 26,
        src: "/assets/images/items/26.jpg",
        alt: "Red cloth Bounded Register",
      },
      {
        id: 27,
        src: "/assets/images/items/27.jpg",
        alt: "Red cloth Bounded Register",
      },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Cashmemo Book": [
      { id: 28, src: "/assets/images/items/28.jpg", alt: "Cashmemo Book" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
    "Rexin Register": [
      { id: 29, src: "/assets/images/items/29.jpg", alt: "Rexin Register" },
      { id: 30, src: "/assets/images/items/30.jpg", alt: "Rexin Register" },
      { id: 99, src: "/assets/images/items/default.jpg", alt: "Default Image" }, // Default image
    ],
  };

  const shorthandImages = imageMapping["Shorthand copy"];
  console.log(shorthandImages);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  // const images =
  //   product?.images && product.images.length > 0
  //     ? product.images
  //     : fallbackImages;

  const handleAddToCart = () => {
    const item = {
      product_id: id,
      quantity,
    };
    dispatch(addToCart(item));
  };

  const handleWishlistToggle = () => {
    const userId = localStorage.getItem("id");
    console.log("userId", userId);

    if (isInWishlist) {
      const wishlistItemId = wishlist.find(
        (item) => item.product_id === id
      )._id;
      dispatch(removeFromWishlistAsync(wishlistItemId));
    } else {
      // Pass userId when adding to wishlist
      dispatch(addToWishlistAsync({ productId: id, userId }));
    }
  };

  const fallbackImages = [
    { src: "/assets/images/items/30.jpg", alt: "Fallback Image 1" },
    { src: "/assets/images/items/20.jpg", alt: "Fallback Image 2" },
    { src: "/assets/images/items/19.jpg", alt: "Fallback Image 3" },
  ];

  //  const images =
  //    product?.title && imageMapping[product.title]
  //      ? imageMapping[product.title]
  //      : fallbackImages;

  const images =
    product?.title && imageMapping[product.title]
      ? imageMapping[product.title]
      : fallbackImages;

  // console.log("images:", product.title);
  // console.log("images:", imageMapping[]);
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading product: {error}</div>;
  }

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="row">
          {/* Left Column: Image Slider */}
          <div className="col-md-5 col-12 d-flex flex-column align-items-center">
            {/* Slider Section */}
            {/* <Slider {...sliderSettings} className="w-100 mb-3">
              {images.map((image, index) => (
                <div
                  key={image.id || index}
                  className="d-flex justify-content-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid rounded shadow-lg"
                    style={{ maxWidth: "90%" }}
                  />
                </div>
              ))}
            </Slider> */}
            <Slider {...sliderSettings} className="w-100 mb-3">
              {images.map((image, index) => (
                <div
                  key={image.src || index}
                  className="d-flex justify-content-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid rounded shadow-lg"
                    style={{ maxWidth: "90%" }}
                  />
                </div>
              ))}
            </Slider>

            {/* Bottom Images Section */}
            <div className="w-100 d-flex justify-content-between my-4">
              <div
                className="bottom-image-container"
                style={{ flex: 1, marginRight: "1%" }}
              >
                <img
                  src="/assets/images/items/20.jpg"
                  alt="Additional Image 1"
                  className="img-fluid rounded shadow-sm"
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
              <div
                className="bottom-image-container"
                style={{ flex: 1, marginLeft: "1%" }}
              >
                <img
                  src="/assets/images/items/25.jpg"
                  alt="Additional Image 2"
                  className="img-fluid rounded shadow-sm"
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
            </div>
          </div>

          {/* Right Column: Product Details Card */}
          <div className="col-md-7 col-12">
            <div className="card">
              <div className="card-body">
                <h2
                  className="card-title text-center"
                  style={{ marginTop: "50px" }}
                >
                  {product?.title || "Spiral binding notebook"}
                </h2>
                <p className="text-center text-muted card-text">
                  {product?.description ||
                    "Spiral bounded notebook for maintaining notes"}
                </p>
                <h3 className="text-success text-center">
                  Rs. {product?.price || 28}{" "}
                  <small>(MRP incl. of all taxes)</small>
                </h3>

                {/* Pages Section */}
                <div className="mt-4">
                  <h4>Pages:</h4>
                  <div className="d-flex flex-wrap gap-2">
                    {[
                      "104",
                      "140",
                      "180",
                      "212",
                      "224",
                      "240",
                      "268",
                      "306",
                      "336",
                      "400",
                    ].map((page, index) => (
                      <button key={index} className="btn btn-outline-dark mb-2">
                        {page}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Ruling Section */}
                <div className="mt-4">
                  <h4>Ruling:</h4>
                  <div className="d-flex flex-wrap gap-2">
                    {[
                      "1 Line (Single Line)",
                      "Plain",
                      "Single Line Interleaf",
                      "Single Line 3-In-1",
                      "Single Line 6-In-1",
                    ].map((rule, index) => (
                      <button key={index} className="btn btn-outline-dark mb-2">
                        {rule}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Quantity Section */}
                <div className="mt-4">
                  {/* Quantity Section */}
                  <h4>Quantity:</h4>
                  <div className="input-group" style={{ width: "163px" }}>
                    <button
                      className="btn btn-outline-secondary"
                      // onClick={handleDecreaseQuantity}
                      style={{ fontWeight: "bold" }}
                    >
                      <i className="fa fa-minus"></i>
                    </button>
                    <input
                      type="number"
                      min="1"
                      value={quantity}
                      onChange={(e) =>
                        setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                      }
                      className="text-center"
                      style={{
                        width: "60px",
                        border: "1px solid #ddd",
                        textAlign: "center",
                      }}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      // onClick={handleIncreaseQuantity}
                      style={{ fontWeight: "bold" }}
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>

                  {/* Action Buttons Section */}
                  <div className="mt-4">
                    <div className="d-flex w-75 justify-content-between align-items-center">
                      <button
                        className="btn btn-primary w-75 mt-2"
                        onClick={handleAddToCart}
                        disabled={cartLoading}
                      >
                        {cartLoading ? "Adding to Cart..." : "Add to Cart"}
                      </button>
                      {cartError && <p className="text-danger">{cartError}</p>}
                      <i
                        className={`fa fa-heart ${
                          isInWishlist ? "text-danger" : ""
                        }`}
                        aria-hidden="true"
                        onClick={handleWishlistToggle}
                        style={{ cursor: "pointer", fontSize: "24px" }}
                      ></i>
                    </div>
                    <button
                      className="btn btn-success w-75 mt-2"
                      onClick={handleShow}
                    >
                      Buy It Now
                    </button>
                  </div>

                  {/* Shipping Information Section */}
                  <div
                    className="d-flex align-items-center mt-3 p-2"
                    style={{
                      backgroundColor: "#fff1f1",
                      border: "1px solid #f2dede",
                      borderRadius: "4px",
                      color: "#e51b23",
                      fontSize: "14px",
                    }}
                  >
                    <i
                      className="fa fa-truck"
                      style={{ fontSize: "18px", marginRight: "8px" }}
                    ></i>
                    Order in next few hours to get it within next 4-7 days.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}

      {/* Checkout Modal */}
      <Checkout showModal={showModal} handleClose={handleClose} />
    </>
  );
};

export default ProductPage;
